export default "__VITE_ASSET__c28269a7__"